module.exports = __webpack_public_path__ + "img/big-monitor.7e2fbc06.png";